import {DatePipe} from '@angular/common';
import {CHECKED_VALUES} from 'src/app/domain/command/command.command';
import {getYearsDiff} from 'src/app/domain/function/date.helper';
import {uuid} from 'src/app/domain/function/uuid.helper';
import {ChildFixture} from 'src/app/domain/model/child/child-fixture.model';
import {initializeChild} from 'src/app/domain/model/child/child.model';
import {Plan} from 'src/app/domain/model/plan/plan.model';
import {Address} from 'src/app/domain/model/shared/address.model';
import {UpdateChildPlanDataCommand} from 'src/app/domain/command/child/child.command';
import {getZipCodeFormatted} from 'src/app/domain/service/api/fixtures.api';

export const createUpdateChildDataFromPlan = (plan: Plan, parentAddress: Address): UpdateChildPlanDataCommand => {
  if (!plan.child) {
    plan.child = initializeChild();
  }

  const childData: UpdateChildPlanDataCommand = {
    commandId: uuid(),
    name: plan.child.name,
    surname: plan.child.surname,
    vat: plan.child.vat,
    birthdate: plan.child.birthdate ? plan.child.birthdate : null,
    nationality1: plan.child.nationalities?.length > 0 ? plan.child.nationalities[0].country : '',
    nationality2: plan.child.nationalities?.length > 1 ? plan.child.nationalities[1].country : '',
    nationality3: plan.child.nationalities?.length > 2 ? plan.child.nationalities[2].country : '',
    sex: plan.child.sex,
    country: plan.child.address?.country,
    postalStreetType: plan.child.address?.postalStreetType,
    postalStreet: plan.child.address?.postalStreet,
    postalStreetNumber: plan.child.address?.postalStreetNumber,
    postalExtraData: plan.child.address?.postalExtraData,
    state: plan.child.address?.state,
    city: plan.child.address?.city,
    zip: plan.child.address?.zipCode,
    sameParentAddress: CHECKED_VALUES.on,
    childUnderAge: ''
  };

  if ((childData.country && childData.country !== parentAddress.country) ||
    (childData.postalStreetType && childData.postalStreetType !== parentAddress.postalStreetType) ||
    (childData.postalStreet && childData.postalStreet !== parentAddress.postalStreet) ||
    (childData.postalStreetNumber && childData.postalStreetNumber !== parentAddress.postalStreetNumber) ||
    (childData.postalExtraData && childData.postalExtraData !== parentAddress.postalExtraData) ||
    (childData.state && childData.state !== parentAddress.state) ||
    (childData.city && childData.city !== parentAddress.city) ||
    (childData.zip && childData.zip !== parentAddress.zipCode)) {
    childData.sameParentAddress = CHECKED_VALUES.off;
  }

  if (getYearsDiff(new Date(childData.birthdate), new Date()) < 18) {
    childData.childUnderAge = CHECKED_VALUES.on;
  }

  return childData;
};

export const createUpdateChildDataFromFixture = (childFixture: ChildFixture, additionalParams?: any): UpdateChildPlanDataCommand => {
  const surnameList = childFixture?.name.last?.split(' ') || [];
  const firstSurname = surnameList.join(' ');

  const command: UpdateChildPlanDataCommand = {
    commandId: uuid(),
    name: childFixture?.name.first,
    surname: firstSurname,
    vat: '',
    birthdate: new DatePipe(navigator.language).transform(new Date(), 'yyyy-MM-dd') ?? null,
    nationality1: childFixture?.nat,
    nationality2: '',
    nationality3: '',
    sex: childFixture?.gender,
    country: childFixture?.location.country,
    postalStreetType: 'Calle',
    postalStreet: childFixture?.location.street.name,
    postalStreetNumber: childFixture?.location.street.number,
    postalExtraData: null,
    state: childFixture?.location.state,
    city: childFixture?.location.city,
    zip: getZipCodeFormatted(childFixture?.location.postcode),
    sameParentAddress: CHECKED_VALUES.on,
    childUnderAge: '',
    ...additionalParams
  };

  return command;
};
